export default "__VITE_ASSET__PCN_RvbU__"